import styled from 'styled-components';
import { FlexRow } from '../../../ui-toolkit';

export const CursorFlexRow = styled(FlexRow)`
  cursor: pointer;
`;
